(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    class DorProductShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.dor-product-share__button');
      this.label = this.querySelector('[data-share-label]');
      this.status = this.querySelector('[data-share-status]');

      if (!this.button || this.button.dataset.shareReady === 'true') return;

      this.button.dataset.shareReady = 'true';
      this.button.addEventListener('click', () => this.share());
      this.setupSocialShare();
    }

    setupSocialShare() {
      this.socialDialog = this.querySelector('.dor-product-share__dialog');
      if (!this.socialDialog) return;
      this.caption = this.querySelector('[data-social-caption]');
      this.socialStatus = this.querySelector('[data-social-status]');
      this.querySelector('[data-social-open]').addEventListener('click', () => {
        this.updateSocialLinks();
        this.socialStatus.textContent = '';
        this.socialDialog.showModal();
      });
      this.querySelector('[data-social-close]').addEventListener('click', () => this.socialDialog.close());
      this.caption.addEventListener('input', () => {
        this.updateSocialLinks();
        this.socialStatus.textContent = '';
      });
      this.querySelector('[data-social-copy]').addEventListener('click', () => this.copyPost());
      const nativeButton = this.querySelector('[data-social-native]');
      nativeButton.hidden = typeof navigator.share !== 'function';
      nativeButton.addEventListener('click', () => this.sharePost());
      this.updateSocialLinks();
    }

    getSocialPost() {
      const text = this.caption.value.trim();
      const url = this.dataset.url;
      return { title: this.dataset.title, text, url, post: [text, url].filter(Boolean).join('\n') };
    }

    updateSocialLinks() {
      const { text, url, post } = this.getSocialPost();
      this.querySelector('[data-social-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(post);
      this.querySelector('[data-social-x]').href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url);
    }

    async sharePost() {
      const { title, text, url } = this.getSocialPost();
      try {
        await navigator.share({ title, text, url });
      } catch (error) {
        if (error?.name !== 'AbortError') this.socialStatus.textContent = this.dataset.shareErrorLabel;
      }
    }

    async copyPost() {
      const { post } = this.getSocialPost();
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(post);
          copied = true;
        }
      } catch (error) {}
      if (!copied) {
        try { copied = this.legacyCopy(post); } catch (error) {}
      }
      this.socialStatus.textContent = copied ? this.dataset.postCopiedLabel : this.dataset.copyErrorLabel;
      if (!copied) this.caption.focus();
    }

    async share() {
      const title = this.dataset.title || document.title;
      const url = this.dataset.url || window.location.href;

      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }

      await this.copy(url);
    }

    async copy(url) {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          this.legacyCopy(url);
        }
      } catch (error) {
        this.legacyCopy(url);
      }

      this.showCopied();
    }

    legacyCopy(url) {
      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      const copied = document.execCommand('copy');
      field.remove();
      return copied;
    }

    showCopied() {
      const copied = this.dataset.copiedLabel || 'Link copied';
      const original = this.dataset.shareLabel || 'Share';

      if (this.label) this.label.textContent = copied;
      if (this.status) this.status.textContent = copied;

      window.clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => {
        if (this.label) this.label.textContent = original;
        if (this.status) this.status.textContent = '';
      }, 1800);
    }
  }

  if (!customElements.get('product-share')) {
    customElements.define('product-share', DorProductShare);
  }
  } catch(e) { console.error(e); }
})();

})();
